import { defineComponent, ref, provide, reactive, toRefs, getCurrentInstance, onMounted, nextTick, onBeforeUnmount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PageLoading from '@/components/common/PageLoading.vue';
import Swiper from '@/components/layout/Swiper.vue';
import SearchBar2 from '@/components/layout/SearchBar2.vue';
import Header2 from '@/components/layout/header2.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import bus from 'vue3-eventbus'
import SideComponent from '@/components/common/SideComponent.vue';
import { wexinShare } from '@/utils/wxshare.js';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import HLS from 'hls.js';
// import EasyPlayer from '@easydarwin/easyplayer';
// import DecoderPlayer from 'decoderplayer';
// import H265Player from 'vue-h265-player';
// import VConsole from 'vconsole';

export default defineComponent({
	components: {
		PageLoading,
		Header2,
		Menu,
	    Swiper,
	    SearchBar2,
	    Footer,
	    SideComponent,
	    // EasyPlayer,
	    // DecoderPlayer
	    // H265Player,
	},
	props: {

	},
	setup() {
		let {ctx, proxy} = getCurrentInstance();
		const router = useRouter();
	    const route = useRoute();
	    let id = route.query.id;
		const data = reactive({
			isMobile: false,
			isLoading:true,
			showHeader: true,
			loginStyle: "min-width:141px;",
			mobileIconStyle: "color:rgba(223, 58, 8, 1);",
			showListIcon: true,
			imageSrc: '',
			//定义一个imageNew变量来接收裁剪之后的图片
			imageNew: '',
			picCats: [

      		],
      		videos:[],
		    videoDetail:{},
		    page:1,
      		nomore:true,
      		keyword:'',
      		id: 0,
      		activity:{},
      		keywords: [],
      		player: null,
      		actid: 0,
	      	videoOptions: {
		        controls: true,//开启交互，即是用户可控。
		        muted: true,//开启视频时是否静音
		        fluid: true,//根据外层css样式大小，自动填充宽高！比较实用，可搭配响应式
		        reload: "metadata",//重载
		        //其余设置根据需求添加！
		        poster: '',//视频封面
		        sources: [],
				techOrder: ['html5'],
				bufferTime: 7, // 单位：秒，建议5-10秒平衡卡顿与延迟
				// html5: {
				//     hlsjsConfig: {
				//         enableWorker: true,
				//         enableSoftwareAES: true
				//     }
				// },
				html5: {
				    hls: {
				      enableLowInitialPlaylist: false, // 关闭初始低画质锁定
				      overrideNative: true            // 强制使用Video.js的HLS处理逻辑
				    }
				},
				hls: {
				    overrideNative: true
				},

		    },
		    sources:{
	            src: '',
	            type: "video/mp4"
	        },
		});
		data.id = id;
		
		const showMenu = ref(proxy.$menus);
		provide('showMenu', showMenu);

		const outerStyleStr = ref("position:relative;left:10%;top:40%;transform:translate(-10%,-40%);width:auto;");
		provide('outerStyleStr', outerStyleStr);

		const styleStr = ref("height:45px;");
		provide('styleStr', styleStr);

		const showSearchText = ref(false);
		provide('showSearchText', showSearchText);

		const getImageUrl = (name) => {
		    return proxy.$utils.getImageUrl(name);
		};

		//点击裁剪按钮
		const updateImageSrc = (updateImageSrc) => {
		  	imageNew.value = updateImageSrc
		}
		const store = useStore();		
	    const getVideoList = (actid,page=1) => {
	    	console.log(data.actid,'actid')
	    	// data.keyword = keyword;
        	store.dispatch("user/getOneCollects",{
	        	page: page,
	        	actid: actid
	        }).then((res) => {
	        	if(res.data.length > 0){
	        		if(page == 1){
	        			data.videos = res.data;
	        		}else{
	        			data.videos = data.videos.concat(res.data);
	        		}
					
					if(res.data.length < res.pagination.pageSize){
						data.nomore = true;
					}else{
						data.nomore = false;
					}
				}else{
					data.nomore = true;
				}        
	        	// data.pagination = res.pagination;
	        	data.page += 1;
	        	bus.emit('showFooter',true);
	        })
        }
        
	    
      	
      	const getVideo = (id=0) => {
      		store.dispatch("user/getCollectDetail",{
	        	id:id,
	        }).then((res) => {
	        	console.log(res,"video-active");
	        	// data.videoDetail = null;
	        	data.videoDetail = res
	        	data.videoDetail.size = Math.round(data.videoDetail.size / 1024);
	        	data.videoOptions.poster = res.thumb ? res.thumb:new URL('../assets/img/logo.png', import.meta.url).href;//res.thumb;
				data.sources.src = res.url;
				data.videoOptions.sources.push(data.sources);
				data.actid = res.actid;
	        	// if(data.videoDetail.keywords){
	        	// 	data.videoDetail.keywords = [];
	        	// }
	        	if(!data.videoDetail.keywords){
	        		data.videoDetail.keywords = [];
	        	}else{
	        		if(data.videoDetail.keywords.indexOf(',')!==-1){
	        			data.keywords = data.videoDetail.keywords.split(',');
	        		}else if(data.videoDetail.keywords.indexOf('，')!==-1){
	        			data.keywords = data.videoDetail.keywords.split('，');
	        		}else{
	        			data.keywords = data.videoDetail.keywords;
	        		}
	        	}
	        	proxy.$utils.getImageSize(res.thumb).then((imginfo)=>{
	        		// console.log(imginfo,'imginfo');
	        		if(parseInt(imginfo.width) < parseInt(imginfo.height)){
	        			data.videoDetail.direction = 3;
	        		}else if(parseInt(imginfo.width) > parseInt(imginfo.height)){
	        			data.videoDetail.direction = 2;
	        		}else if(parseInt(imginfo.width) == parseInt(imginfo.height)){
	        			data.videoDetail.direction = 1;
	        		}

	        	});
	        	// proxy.$utils.getImageSize(res.thumb).then((imginfo)=>{
	        	// 	// console.log(imginfo,'imginfo');
	        	// 	if(parseInt(imginfo.width) < parseInt(imginfo.height)){
	        	// 		data.videoDetail.direction = 3;
	        	// 	}else if(parseInt(imginfo.width) > parseInt(imginfo.height)){
	        	// 		data.videoDetail.direction = 2;
	        	// 	}else if(parseInt(imginfo.width) == parseInt(imginfo.height)){
	        	// 		data.videoDetail.direction = 1;
	        	// 	}

	        	// });
	        	// initPlayer();
	        	if(document.documentElement.clientWidth < 768){
					initPlayer();
				}else{
					
				}
	        	data.activity = res.activity
	        	getVideoList(data.actid);
	        	wxshare(res)
	        })
      	}

      	const initPlayer = () => {
      		// data.player = null;
	      data.player = videojs(proxy.$refs.videoPlayer, data.videoOptions, () => {
	        console.log('Player is ready');
	      });
	      // data.player.ready(() => {
	      // 	data.player.play();
	      // })
	      data.player.errorDisplay.close();
	    }

      	const wxshare = (share_data) => {
			const protocol = window.location.protocol; // 协议 (e.g., "https:")
			const hostname = window.location.hostname; // 域名 (e.g., "example.com")
			let url = protocol+'//'+hostname;
			if(hostname.indexOf("www") == -1){
				url = protocol+'//www.'+hostname;
			}
			url = url+route.fullPath;
			store.dispatch("common/Jssdk",{
				url:url
			}).then((res) => {
				// console.log(res,'jssdk');
				//微信加签              
                // var shareWxLink = encodeURIComponent(url);加密
                let shareData = {
                    title: share_data.title, // 分享标题
                    desc:'',
                    link: url,
                    imgUrl: store.state.common.siteInfo.logo // 分享图标
                };
                //引用
                wexinShare(res, shareData);
	        })
		}
		const errorFunc = (event) => {

		}
		
		const viewBox = ref(null);
        const scroll = (val) => {
			if(val == 'top'){
				
				viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });
		       
			}else if(val == 'bottom'){
				
				viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "end", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });

			}
		}

		onMounted(async()=>{	
			// new VConsole();		
			await getVideo(data.id);
        	await nextTick(()=>{
        		
        		
        	})

        	setTimeout(() => {
		        data.isLoading = false;
		        viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });
		    }, 600);
		    console.log("页面数据更新完毕了")
        })


		const refData = toRefs(data);

		return {
			...refData,
			getImageUrl,
			updateImageSrc,
			getVideo,
			getVideoList,
			viewBox,
			scroll,
			wxshare,
			initPlayer,
			errorFunc,
		}
	},
	created() {

	},
	mounted() {
		this.$nextTick(() => {
			this.init();
		});
	},
	methods: {
		handleOnError(error) {
	        console.log('error: ', error);
	    },
		init() {
			if(document.documentElement.clientWidth < 768){
				this.isMobile = true;
			}else{
				this.isMobile = false;
			}

			document.oncontextmenu=function(){
	      	   window.event.returnValue=true;
	        };
	        window.addEventListener( 'keydown', function ( event ) {

	          //禁用F12
	          if (event.key == "F12") {
	            event.preventDefault(); // 如果按下键F12,阻止事件
	          }
	          if (event && event.keyCode == 123) {
	              return true;
	          //禁用ctrl+shift+i,
	          } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
	              return true;
	          //屏蔽Shift+F10
	          } else if (event.shiftKey && event.keyCode == 121) {
	              return true;
	          }
 
	        } );
		},
		activeStyle(item) {		
			if(item.ratio_w == null || item.ratio_h == null || item.ratio_w == "" || item.ratio_h == "") {
				(async () => {
				    let size = await this.$utils.getImageSize(item.thumb);
				    // console.log(size,"size");
				    item.ratio_w = size.width;
				    item.ratio_h = size.height;
				})();

			}
			let object = {};
			object.width = item.ratio_w*200/item.ratio_h+'px';

			return object;
		},
		handleMouseEnter(event) {
	      // console.log(event.target,'鼠标移入');
	      event.target.play();
	    },
	    handleMouseLeave(event) {
	      // console.log(event.target,'鼠标移出');
	      event.target.pause();
	    },
		loadMore() {
			this.getVideoList(this.keyword, this.page);
		},
		changeVideoinfo(id){
			let that = this;
			// this.getVideo(id);
			let href = this.$router.resolve({ //使用resolve
		      name:'active_collect_video_detail',    //这里是跳转页面的name
		      path: '/active_collect_video_detail',
		      query:{ id: id },
		    })
		    window.open(href.href, '_self')

		},
		realTime(data) {
			// console.log(data,"data");
  			var previews = data;
  			this.previews = data
  		},
  		/*
		  loadeddata 事件在媒体当前播放位置的视频帧（通常是第一帧）加载完成后触发
		  preload为none时不会触发
		*/
		// getPoster () { // 在未设置封面时，自动截取视频0.5s对应帧作为视频封面
		//   // 由于不少视频第一帧为黑屏，故设置视频开始播放时间为0.5s，即取该时刻帧作为封面图
		//   veo.value.currentTime = props.second
		//   // 创建canvas元素
		//   const canvas = document.createElement('canvas')
		//   const ctx = canvas.getContext('2d')
		//   // canvas画图
		//   canvas.width = veo.value.videoWidth
		//   canvas.height = veo.value.videoHeight
		//   ctx?.drawImage(veo.value, 0, 0, canvas.width, canvas.height)
		//   // 把canvas转成base64编码格式
		//   veoPoster.value = canvas.toDataURL('image/png')
		// },

	},
})